export const LANGUAGE_STORAGE_KEY = 'BUCKE_DASHBOARD_LANGUAGE';

export enum SupportedLanguage {
    EN = 'en',
    FR = 'fr',
    NL = 'nl',
}

// en-GB first to avoid US formatting in non US countries
export const SUPPORTED_LOCALES = ['en-GB', 'en-US', 'nl', 'fr'];
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];
export const DEFAULT_LOCALE: SupportedLocale = 'nl';
// Must match filenames of the files in assets/i18n for *all* embedded apps
export const SUPPORTED_LANGUAGES = Object.values(SupportedLanguage) as SupportedLanguage[];
export const DEFAULT_LANGUAGE = SupportedLanguage.NL;
